// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import App from "./App";
import { registerServiceWorker } from "./registerServiceWorker";

// ── Ngrok fetch interceptor — must be set up before any fetch calls ────────
if (typeof window !== "undefined") {
  const _origFetch = window.fetch.bind(window);
  window.fetch = function(url, opts = {}) {
    const urlStr = typeof url === "string" ? url : (url?.url || "");
    if (urlStr.includes("ngrok") || urlStr.includes("trycloudflare")) {
      const headers = new Headers(opts.headers || {});
      headers.set("ngrok-skip-browser-warning", "true");
      opts = { ...opts, headers };
    }
    return _origFetch(url, opts);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />); // StrictMode removido para evitar double-render em dev

registerServiceWorker();
